import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
//
import DealReducer from 'store/deals/reducer';
import { IDeal, IDealState } from 'store/deals/types';
import { IFieldOptionState } from 'store/field-options/types';
import FieldOptionReducer from 'store/field-options/reducer';
import SidebarReducer from 'store/sidebar/reducer';
import { ISidebarState } from 'store/sidebar/types';
import DealEditReducer from 'store/deal-edit/reducer';
import GeneralReducer from 'store/general/reducer';
import { IGeneralState } from 'store/general/types';
import LoadingReducer from 'store/loading/reducer';
import { ILoadingState } from 'store/loading/types';
import ModalReducer from 'store/modal/reducer';
import { IModalState } from 'store/modal/types';
import DealComparisonReducer from 'store/deal-comparison/reducer';
import { IDealComparisonState } from 'store/deal-comparison/types';
import DealEvaluationReducer from 'store/deal-evaluation/reducer';
import { IDealEvaluationState } from 'store/deal-evaluation/types';
import FormulaEntryReducer from 'store/formula-entry/reducer';
import { IFormulaEntryState } from 'store/formula-entry/types';
import CostFormulasReducer from 'store/cost-formulas/reducer';
import { ICostFormulasState } from 'store/cost-formulas/types';
import ParetoReducer from 'store/pareto/ParetoReducer';
import { IParetoState } from 'store/pareto/types';
import BookmarkReducer from 'store/bookmark/reducer';
import { IBookmarkState } from 'store/bookmark/types';
import AddNewUpdateReducer from 'store/add-new-update/AddNewUpdateReducer';
import { IAddNewUpdateState, IUpdateContent } from 'store/add-new-update/types';

export interface IStoreState {
  costFormulas: ICostFormulasState;
  dealEdit: IDeal;
  deals: IDealState;
  fieldOptions: IFieldOptionState;
  formulaEntry: IFormulaEntryState;
  general: IGeneralState;
  dealComparison: IDealComparisonState;
  dealEvaluation: IDealEvaluationState;
  loading: ILoadingState;
  modal: IModalState;
  pareto: IParetoState;
  sidebar: ISidebarState;
  bookmark: IBookmarkState;
  addNewUpdate: IAddNewUpdateState;
  updateContent: IUpdateContent;
}

const reducers = combineReducers({
  costFormulas: CostFormulasReducer,
  dealEdit: DealEditReducer,
  deals: DealReducer,
  fieldOptions: FieldOptionReducer,
  formulaEntry: FormulaEntryReducer,
  general: GeneralReducer,
  dealComparison: DealComparisonReducer,
  dealEvaluation: DealEvaluationReducer,
  loading: LoadingReducer,
  modal: ModalReducer,
  pareto: ParetoReducer,
  sidebar: SidebarReducer,
  bookmark: BookmarkReducer,
  addNewUpdate: AddNewUpdateReducer,
});

export default createStore(reducers, composeWithDevTools(applyMiddleware(thunk)));
